import React from "react";

const FieldValidationContext = React.createContext( {} );

export default FieldValidationContext;